import { RouteConfig } from "vue-router";

export const RLogin: RouteConfig = {
  path: "login",
  name: "Login",
  component: () =>
    import(
      /* webpackChunkName: "auth-login" */
      "./VLogin.vue"
    ),
};
